module.exports = __webpack_public_path__ + "assets/img/ajfxpt.30caac6f.png";